export enum TreeLevel {
    l1 = 'user',
    l2 = 'customer', 
    l3 = 'region', 
    l4 = 'project',
    l5 = 'simulation'
  }